module.exports = __webpack_public_path__ + "img/d1@2x.5f812700.png";